import { ACCREDITATION_ROLES } from 'libs/utils/src/lib/player-portals/constants/pp-accreditation-roles';
import { GroupKey } from '../types';

const GROUPS = {
  playerAndCaddie: 'playerAndCaddie',
  supportTeam: 'supportTeam',
  guests: 'guests',
  children: 'children',
};

const CATEGORY_ORDER: GroupKey[] = [
  GROUPS.playerAndCaddie,
  GROUPS.supportTeam,
  GROUPS.guests,
  GROUPS.children,
];

const CATEGORY_VALUES: Record<GroupKey, string[]> = {
  playerAndCaddie: [
    ACCREDITATION_ROLES.player.label,
    ACCREDITATION_ROLES.caddie.label,
  ],
  supportTeam: [
    ACCREDITATION_ROLES.playerSupportManager.label,
    ACCREDITATION_ROLES.playerSupportCoach.label,
    ACCREDITATION_ROLES.playerSupportMedical.label,
    ACCREDITATION_ROLES.playerSupportTranslator.label,
  ],
  guests: [
    ACCREDITATION_ROLES.playerGuest.label,
    ACCREDITATION_ROLES.playerVIP.label,
  ],
  children: [ACCREDITATION_ROLES.playerChildren.label],
};

export { GROUPS, CATEGORY_ORDER, CATEGORY_VALUES };
